import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import {
  getEscalationConfig,
  updateEscalationConfig,
} from "../Api/ApiCalls";
import LoadingSpinner from "../common/Loading";
import { configurationValidationSchema } from "../common/Validation";
import log from "../core/log";

export const Configuration = () => {
  const [loading, setLoading] = useState(false);
  const [configData, setConfigData] = useState(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm({ 
    resolver: yupResolver(configurationValidationSchema),
    mode: "onChange"
  });

  const onSubmit = async (data) => {
    console.log("Form data:", data);
    console.log("Form errors:", errors);
    
    setLoading(true);
    try {
      const result = await updateEscalationConfig({
        escalation_threshold_days: parseInt(data.escalation_threshold_days)
      });
      
      if (result.status) {
        toast.success("Configuration updated successfully");
        setConfigData({
          ...configData,
          escalation_threshold_days: parseInt(data.escalation_threshold_days)
        });
      } else {
        toast.error(result.message || "Failed to update configuration");
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      log("Error while updating configuration ", err);
      toast.error("Error updating configuration");
      setLoading(false);
    }
  };

  const getConfiguration = async () => {
    try {
      setLoading(true);
      const result = await getEscalationConfig();
      if (result.status) {
        setConfigData(result.data);
        reset({
          escalation_threshold_days: result.data.escalation_threshold_days || ""
        });
        // Show message if configuration was created with default value
        if (result.message && result.message.includes("created with default value")) {
          toast.info("Configuration created with default value of 5 days");
        }
      } else {
        toast.info(result.message || "Configuration not found");
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      log("Error while fetching configuration ", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    getConfiguration();
  }, []);

  return (
    <>
      <div className="grid grid-rows-1">
        <div className="flex overflow-hidden">
          <div className="content relative flex-1 pb-10">
            <form onSubmit={handleSubmit(onSubmit)}>
              <h2 className="text-4xl text-[#96BF61] font-bold">
                Configuration
              </h2>

              {loading && <LoadingSpinner />}
              <div className="grid grid-cols-12 mt-5">
                <div className="col-span-12 lg:col-span-12">
                  <div className="shadow-md rounded">
                    <div className="bg-white rounded-[21px] p-10 mt-6">
                      <div className="">
                        <div className="flex flex-col sm:flex-row items-start">
                          <div className="flex items-center space-x-4">
                            <div className="flex-shrink-0">
                              <label
                                htmlFor="escalation_threshold_days"
                                className="text-black font-semibold text-sm block"
                              >
                                Escalation delay (in days):
                                <span className="text-red-600">*</span>
                              </label>
                              <p className="text-gray-600 text-xs italic mt-1 w-52">
                                Number of days to wait after product expiry before sending an escalation email.
                              </p>
                            </div>
                            <div className="relative">
                              {errors?.escalation_threshold_days?.message && (
                                <span className="text-red-600 absolute -top-6 left-0 text-xs whitespace-nowrap">
                                  {errors.escalation_threshold_days.message}
                                </span>
                              )}
                              <input
                                id="escalation_threshold_days"
                                type="number"
                                {...register("escalation_threshold_days")}
                                className={`py-3 block shadow-md px-4 bg-transparent border border-b-2 appearance-none w-32 focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md`}
                                placeholder="Days"
                                max={30}
                                min={1}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="pt-12 text-right">
                          <button
                            disabled={loading}
                            type="submit"
                            className="px-4 py-2 text-lg text-white transition-all duration-150 ease-linear rounded-md shadow outline-none font-semibold bg-[#024C85] hover:bg-[#134d86] hover:shadow-lg focus:outline-none disabled:opacity-50"
                          >
                            Update
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
